import { useCallback, useEffect, useState } from 'react';
import authController from '../controllers/AuthController';
import { setToken, setUserRole, setUsername } from '../store/slices/authSlice';
import store from '../store/store';

const useAuthenticate = () => {
  const [userCreds, setUserCreds] = useState<string | null>(null);
  const authenticate = useCallback(async () => {
    const auth = await authController.manageUserAuthentication();
    if (auth?.credential) {
      store.dispatch(setToken(auth.credential?.token));
      store.dispatch(setUserRole(auth?.user?.role));
      store.dispatch(setUsername(auth.user.username));
      authController.getGroupInfoByItemID(auth.user.username);
      setUserCreds(auth.credential?.token);
    }
  }, []);

  useEffect(() => {
    authenticate();
  }, [authenticate]);
  return userCreds;
};

export default useAuthenticate;
